import { takeEvery, call, put, select } from "redux-saga/effects";
import { handleError } from "helpers/HandleError";
import { toast } from "react-toastify";
import { types } from "../reducers/authentication";
import { getRequest, postRequest } from "../../helpers/Api";
import StorageManager from "../../helpers/StorageManager";
import { types as FormTypes } from "../reducers/forms";

const formatError = (error) => Object.values(error.constraints)[0];

export function* userNotAuthorizedHandler() {
  yield put({ type: types.SET_SESSION_EXPIRED, payload: { sessionExpired: true } });
  StorageManager.clearToken();
}
/**
 * Fetch the user and check the token(sign out if is not authorized)
 */
function* fetchUser({ payload }) {
  // eslint-disable-next-line max-len
  const authenticateUser = yield select((state) => state.authentication.authenticateUser);

  if (payload.token && !authenticateUser) {
    try {
      const data = yield call(getRequest, {
        url: "/check-token",
        headers: {
          Authorization: `Bearer ${payload.token}`,
        },
      });

      if (data.status === 401) {
        yield put({ type: types.SIGN_OUT });
        return;
      }
      if (!authenticateUser) {
        if (data.status === 200) {
          StorageManager.set("TOKEN", data.token);
          yield put({
            type: types.USER_FETCHED_SUCCESSFULLY,
            payload: { user: data.user, role: data.user.role },
          });
        } else {
          handleError(data.message || "Internal server error");
        }
      }
    } catch (error) {
      payload.onFailure(error.message || "Internal server error");
    }
  } else if (!authenticateUser) {
    yield put({ type: types.AUTHENTICATION_FAILED, payload: { message: true } });
  }
}

function* authorizeUser({ payload }) {
  try {
    const data = yield call(getRequest, {
      url: "/check-token",
      headers: {
        Authorization: `Bearer ${payload.token}`,
      },
    });

    if (data.status !== 200) {
      handleError("User is not authorized");
    }

    StorageManager.set("TOKEN", payload.token);
    yield put({
      type: types.USER_FETCHED_SUCCESSFULLY,
      payload: { user: data.user, role: data.user.role },
    });
  } catch (error) {
    yield put({ type: types.SIGN_OUT });
  }
}

/**
 * Log in handler
 */
function* logIn({ payload }) {
  // Clear form validations errors
  yield put({ type: FormTypes.CLEAR_VALIDATION_ERRORS });
  yield put({ type: types.CLEAR_ERRORS });

  try {
    const res = yield call(postRequest, {
      url: "/login",
      body: JSON.stringify({
        username: payload.data.email,
        password: payload.data.password,
      }),
      jsonContentType: true,
    });
    // Invalid Password
    if (res.status === 401) {
      yield put({
        type: types.SET_AUTHENTICATION_ERROR,
        payload: {
          error: res.response ? res.response.message : res.message,
        },
      });
      toast.error(res.response ? res.response.message : res.message);
      yield put({ type: types.SET_LOADING_FALSE });
      return;
    }

    // User is not valid
    if (res.status !== 200) {
      switch (res.status) {
        case 400:
          handleError("User is not authorized");
          break;
        case 422:
          handleError(formatError(res.errors[0]) || "User is not authorized");
          break;
        default:
          handleError(res.message || "User is not authorized");
      }
    }
    StorageManager.set("TOKEN", res.token);
    yield put({
      type: types.USER_FETCHED_SUCCESSFULLY,
      payload: { user: res.user, role: res.user.role },
    });
    // window.location.href = `${process.env.REACT_APP_DASHBOARD}/authenticate/${res.token}`;
    // yield put({ type: types.FETCH_USER, payload: { token: res.token } });
  } catch (error) {
    yield put({ type: types.SET_LOADING_FALSE });
    yield put({ type: types.SET_AUTHENTICATION_ERROR, payload: { error: error.message } });
  }
}
/**
 * Sign out the user and redirect to landing page
 */
function* signOut() {
  StorageManager.clearToken();
  window.location.href = "/";
  yield;
}

export default function* saga() {
  yield takeEvery(types.REQUEST_LOGIN, logIn);
  yield takeEvery(types.FETCH_USER, fetchUser);
  yield takeEvery(types.AUTHORIZE_USER, authorizeUser);
  yield takeEvery(types.SIGN_OUT, signOut);
}
